export const downloadAdapter = (data) => (data?.response?.map((res)=>({...res, id: `${res.fileName}${res.timestamp}`})) || [])